import { render, staticRenderFns } from "./ClipboardWithAvatar.vue?vue&type=template&id=710c5b12&"
import script from "./ClipboardWithAvatar.vue?vue&type=script&lang=js&"
export * from "./ClipboardWithAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports